import React, {Fragment} from "react";
import {Breadcrumbs, Paper, Typography, withStyles} from '@material-ui/core';
import SessaoForm from '../../widgets/organizador/sessao-form/sessaoForm';

import Acl from '../../utils/acl';

const styles = theme => ({
    button: {
        margin: theme.spacing(1),
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    root: {
        padding: theme.spacing(3, 2),
    },
});

function OrgNovaSessao(props) {

    const exibirAvancado = Acl.can("organizador.nova-sessao.avancado", true);
    const { classes } = props;

    return (
        <Paper className={classes.root}>
            <Breadcrumbs aria-label="Breadcrumb" className="bradcrumbs">
                <Typography >Organizar</Typography>
                <Typography >Nova sessão</Typography>
            </Breadcrumbs>
            <SessaoForm exibirSessaoAvancado={exibirAvancado}/>
        </Paper>
    );
}

export default (withStyles(styles)(OrgNovaSessao));